import React from 'react';
import { Checkbox, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { TouchAccessibilityWrapper } from '@domains/pdp-common';

import { CheckboxBenefit } from '../../types/benefit';
import { SubItem } from '../sub-item/SubItem';

interface CheckboxItemProps extends CheckboxBenefit {
  borderTopColor?: `var(--${string})`;
}

export const CheckboxItem = React.forwardRef<HTMLDivElement, CheckboxItemProps>(({ borderTopColor, ...item }, ref) => {
  return (
    <ItemContainer key={item.title} ref={ref} borderTopColor={borderTopColor}>
      <Item>
        <TouchAccessibilityWrapper onClick={() => !item.disabled && item.onChecked?.(item.checked)}>
          <ItemLeftWrap>
            <Checkbox
              size='small'
              disabled={item.disabled}
              checked={item.checked}
              style={{ display: 'flex', alignItems: 'baseline' }}
            />
            <ItemLeftTextWarp>
              <Text variant='Body_13_Medium' color={item.disabled ? 'textTertiary' : 'textSecondary'}>
                {item.title}
              </Text>
              {item.subTitle && (
                <>
                  <Text variant='Body_13_Regular' color='textQuaternary'>
                    &middot;
                  </Text>
                  <Text variant='Body_13_Regular' color={item.disabled ? 'textTertiary' : 'textSecondary'}>
                    {item.subTitle}
                  </Text>
                </>
              )}
            </ItemLeftTextWarp>
          </ItemLeftWrap>
        </TouchAccessibilityWrapper>
        <Text variant='Body_13_SemiBold' color={item.checked ? 'textStrong' : 'textDisabled'}>
          {item.totalAmount}
        </Text>
      </Item>
      <SubItemContainer>
        {item.items.map((subItem) => (
          <SubItem key={subItem.content} subItem={subItem} />
        ))}
      </SubItemContainer>
    </ItemContainer>
  );
});

const ItemContainer = styled.div<{ borderTopColor?: string }>`
  padding: 16px 16px 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${({ borderTopColor }) => borderTopColor && `border-top: 1px solid ${borderTopColor};`};
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ItemLeftWrap = styled.div`
  display: flex;
  gap: 8px;
`;

const ItemLeftTextWarp = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SubItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
